module.exports = "<div>\n    <div class=\"form-group\">\n        <label for=\"userPassword\">{{ 'PASSWORD' | translate }}</label>\n        <input [attr.type]=\"passwordType\" class=\"form-control\" id=\"userPassword\" [(ngModel)]=\"password\">\n        <input type=\"checkbox\" #cvPassword [checked]=\"false\" (change)=\"onChange(cvPassword.checked)\" id=\"viewPassword\"/>&nbsp;<label>{{ 'SHOW_PASSWORD' | translate }}</label>\n    </div>    \n    <div *ngIf=\"wrongPassword\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/super_user/profile/profile_change_email_password/profile-change-email-password.component.html
 ** module id = 137
 ** module chunks = 0
 **/